package com.hyperether.goodjob.models

import com.hyperether.goodjob.repository.remote.model.WorkingHours
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class User(
    @SerialName("_id") var _id: String? = null,
    @SerialName("fullName") var fullName: String? = null,
    @SerialName("email") var email: String? = null,
    @SerialName("password") var password: String? = null,
    @SerialName("confirmStatus") var confirmStatus: String? = null,
    @SerialName("role") var role: String? = null,
    @SerialName("hash") var hash: String? = null,
    @SerialName("type") var type: String? = null,
    @SerialName("workspaceId") var workspaceId: String? = null,
    @SerialName("planId") var planId: String? = null,
    @SerialName("subscriptionId") var subscriptionId: String? = null,

    @SerialName("phone") var phone: String? = null,
    @SerialName("zip") var zip: String? = null,
    @SerialName("country") var country: String? = null,
    @SerialName("city") var city: String? = null,
    @SerialName("address") var address: String? = null,
    @SerialName("status") var status: String? = null,
    @SerialName("skils") var skills: List<String>? = null,
    @SerialName("teams") var teams: List<UserTeam?>? = null,
    @SerialName("createdAt") val createdAt: Long? = null,
    @SerialName("updatedAt") val updatedAt: Long? = null,
    @SerialName("customerId") val customerId: String? = null,
    @SerialName("upcomingLeave") val upcomingLeave: String? = null,
    @SerialName("workingHours") var workingHours: WorkingHours? = null,
    @SerialName("pendingPlanId") var pendingPlanId: String? = null,
    @SerialName("subscriptionEndsAt") var subscriptionEndsAt: Long? = null,
    @SerialName("pushToken") var pushToken: String? = null,
    @SerialName("lang") var lang: String? = null
) {

    fun getName(): String {
        return this.fullName.takeIf { it?.isNotEmpty() == true } ?: this.email.orEmpty()
    }

    fun isDifferent(other: User): Boolean {
        val differences = mutableListOf<String>()

        if (this._id != other._id) differences.add("_id: '${this._id}' vs '${other._id}'")
        if (this.fullName != other.fullName) differences.add("fullName: '${this.fullName}' vs '${other.fullName}'")
        if (this.email != other.email) differences.add("email: '${this.email}' vs '${other.email}'")
        if (this.password != other.password) differences.add("password: '${this.password}' vs '${other.password}'")
        if (this.confirmStatus != other.confirmStatus) differences.add("confirmStatus: '${this.confirmStatus}' vs '${other.confirmStatus}'")
        if (this.role != other.role) differences.add("role: '${this.role}' vs '${other.role}'")
        if (this.workspaceId != other.workspaceId) differences.add("workspaceId: '${this.workspaceId}' vs '${other.workspaceId}'")
        if (this.planId != other.planId) differences.add("planId: '${this.planId}' vs '${other.planId}'")
        if (this.phone != other.phone) differences.add("phone: '${this.phone}' vs '${other.phone}'")
        if (this.zip != other.zip) differences.add("zip: '${this.zip}' vs '${other.zip}'")
        if (this.country != other.country) differences.add("country: '${this.country}' vs '${other.country}'")
        if (this.city != other.city) differences.add("city: '${this.city}' vs '${other.city}'")
        if (this.address != other.address) differences.add("address: '${this.address}' vs '${other.address}'")
        if (this.status != other.status) differences.add("status: '${this.status}' vs '${other.status}'")
        if (this.skills != other.skills) differences.add("skills: '${this.skills}' vs '${other.skills}'")
        if (this.teams != other.teams) differences.add("teams: '${this.teams}' vs '${other.teams}'")
        if (this.upcomingLeave != other.upcomingLeave) differences.add("upcomingLeave: '${this.upcomingLeave}' vs '${other.upcomingLeave}'")
//        if (this.workingHours != other.workingHours) differences.add("workingHours: '${this.workingHours}' vs '${other.workingHours}'")
        if (this.pendingPlanId != other.pendingPlanId) differences.add("pendingPlanId: '${this.pendingPlanId}' vs '${other.pendingPlanId}'")
        if (this.subscriptionEndsAt != other.subscriptionEndsAt) differences.add("subscriptionEndsAt: '${this.subscriptionEndsAt}' vs '${other.subscriptionEndsAt}'")
        if (this.lang != other.lang) differences.add("lang: '${this.lang}' vs '${other.lang}'")

        if (differences.isNotEmpty()) {
            println("User differences found:")
            differences.forEach { println("  - $it") }
            return true
        }

        return false
    }
}